<template>
    <div>
        <div class="smallContent miscContent">
            <p>
                All rights reserved. All recordings and written material on this
                website are the sole property of Montez Press Radio and the
                contributors. No part of this material may be reprinted or
                distributed without prior written consent from Montez Press
                Radio and/or the contributors.
            </p>
            <!--
            <p>
                Leadership:<br />
                <a href="mailto:stacy@montezpress.com">Stacy Skolnik</a>,
                Executive Director<br />
                <a href="mailto:thomas@montezpress.com">Thomas Laprade</a>,
                Curatorial Director
            </p>
            <br />
            <p>
                London-based programming curated by Emily Pope and Manda
                Shutler.<br />
                Mexico-based programming curated by Fabiola Talavera and Leah
                Whitman-Salkin.
            </p>
            <br />

            <p>
                Board of Directors: <br />
            -->
            <!-- Anna Clark, President <br /> -->
            <!-- Seth Stolbun, Treasurer <br /> -->
            <!-- Christiane Blattmann, Secretary <br /> -->
            <!-- Martha Fuller Clark <br /> -->
            <!-- Than Clark <br /> -->
            <!-- Margaret Liu Clinton <br /> -->
            <!-- Rafael Foster <br /> -->
            <!-- Jacques Louis-Vidal <br /> -->
            <!-- Jereremy Toussaint-Baptiste<br /> -->
            <!-- C. Spencer Yeh <br /> -->
            <!-- Galen Joseph-Hunter <br /> -->

            <!--
                Anna Clark, President <br />
                Jacques Louis-Vidal, Treasurer <br />
                Jeremy Toussaint-Baptiste, Secretary <br />
                Martha Fuller Clark <br />
                Than Clark <br />
                Rafael Foster <br />
                C. Spencer Yeh <br />
                Galen Joseph-Hunter<br />
            </p>
            <br />

            <p>
                Account Support:
                <a href="mailto:support@montezpress.com"
                    >support@montezpress.com</a
                >
            </p>
            <p>
                Queries and programming proposals:
                <a href="mailto:radio@montezpress.com">radio@montezpress.com</a>
            </p>
            <br />

            <p>
                All rights reserved. All recordings and written material on this
                website are the sole property of Montez Press Radio and the
                contributors. No part of this material may be reprinted or
                distributed without prior written consent from Montez Press
                Radio and/or the contributors.
            </p>
            <br />

            <p>
                Montez Press Radio is funded in part by a grant from the New
                Hampshire Charitable Foundation’s Geoffrey E. Clark and Martha
                Fuller Clark Fund.
            </p>
            <br />

            <p>
                Montez Press Radio’s programs are made possible by the New York
                State Council on the Arts with the support of the Office of the
                Governor and the New York State Legislature.
            </p>
            <br />
            <p>
                Major support for Montez Press Radio is provided by The Andy
                Warhol Foundation for the Visual Arts.
            </p>
            <br />

            <p>
                This program is supported, in part, by public funds from the New
                York City Department of Cultural Affairs in Partnership with the
                City Council.
            </p>
            <br />

            <p>
                Design:
                <a href="http://jmmp.eu" target="_blank"
                    >JMMP – Julian Mader, Max Prediger</a
                >
            </p>
            <p>
                Development:
                <a href="https://dominicosterried.de" target="_blank"
                    >Dominic Osterried</a
                >
            </p>

            -->
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
export default {
    name: "Imprint",
    components: {
        Footer,
    },
};
</script>

<style scoped>
p {
    margin: 0;
}

a {
    color: #aaaaaa;
    cursor: pointer;
}

a:hover {
    color: black;
}

.seperator {
    padding: 0.7rem 1rem 0.8rem;
    /* border-bottom: 1px solid black; */
    /* width: calc(100% - 2rem); */
}
</style>
